var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlayButtoninline = function SvgPlayButtoninline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 33,
    height: 40,
    viewBox: "0 0 33 40"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-43 -35)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "PlayButton_inline_svg__a",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#PlayButton_inline_svg__a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    fillOpacity: 0.4,
    xlinkHref: "#PlayButton_inline_svg__a"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.7,
    d: "M55 110c30.376 0 55-24.624 55-55S85.376 0 55 0v55H0c0 30.376 24.624 55 55 55z",
    mask: "url(#PlayButton_inline_svg__a)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M31.918 18.477c1.425.841 1.422 2.207 0 3.047L2.578 38.856C1.156 39.698 0 39.036 0 37.383V2.618C0 .963 1.158.305 2.579 1.145l29.34 17.332z"
  }))));
};
export default SvgPlayButtoninline;